import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LoggerService } from 'src/app/services/logger.service';
import { EAlertType, IAlertObject, ILatestError } from './alert.constants';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private readonly _alertSub = new Subject();

  get alertSubscription(): Observable<any> {
    return this._alertSub.asObservable();
  }

  openSuccessMessage(message?: string) {
    const obj: IAlertObject = {
      type: EAlertType.SUCCESS,
      message: message ? message : 'Operazione effettuata con successo',
    };
    LoggerService.logInfo(this.constructor.name, 'openSuccessMessage', { obj });
    this._alertSub.next(obj);
  }

  openWarningMessage(message?: string) {
    const obj: IAlertObject = {
      type: EAlertType.WARNING,
      message: message ? message : 'Attenzione',
    };
    LoggerService.logInfo(this.constructor.name, 'openWarningMessage', { obj });
    this._alertSub.next(obj);
  }

  openErrorMessage(
    message: string,
    caller: string,
    error?: any,
    isFromAsyncOperation: boolean = false,
  ) {
    let obj: IAlertObject;
    if (isFromAsyncOperation) {
      const text = this.parseAsyncOperationError(message);
      obj = {
        type: EAlertType.ERROR,
        message: text,
      };
    } else {
      const bodyMessage = error?.error?.message
        ? error?.error?.message.split(':')[1]
        : null;
      const text = bodyMessage
        ? bodyMessage
        : message
          ? message
          : 'Errore generico';
      const status = error?.status ? ` (${error.status})` : '';
      const traceId = error?.headers?.get('X-Amzn-Trace-Id');
      const traceMsg = traceId ? `: ${traceId}` : '';
      obj = {
        type: EAlertType.ERROR,
        message: `${text} [${caller}${status}${traceMsg}]`,
      };
    }
    LoggerService.logInfo(this.constructor.name, 'openErrorMessage', { obj });
    this._alertSub.next(obj);
  }

  parseAsyncOperationError(error: string): string {
    try {
      const errorObj: ILatestError = JSON.parse(error);
      let message = 'Errore generico';
      if (errorObj) {
        message = `${typeof errorObj.description === 'string' ? errorObj.description : 'Errore generico'} [${errorObj.traceId}]`;
      }
      return message;
    } catch {
      // If error, it's because of the JSON.parse
      return error
    }
  }
}
